import type { Collection } from "./types";

export const COLLECTIONS: Collection[] = [
  {
    slug: "bodrum-gulet-chic",
    title: "Bodrum Gulet Chic",
    subtitle: "Mavi yolculuğun en zarif hali. Ahşap bir teknede, koydan koya.",
    vibe: "serene",
    heroGradient: "from-sky-900 via-teal-800 to-amber-700",
    icon: "Sailboat",
    highlights: [
      "Özel guletle yedi gün Ege koyları",
      "Güneş batarken şampanya demlenmiş güvertede",
      "Gökova, Orak, Cleopatra koyları rotası",
      "Yerel balıkçılardan taze meze sofraları",
      "Şef eşliğinde yat mutfağı deneyimi",
    ],
    sampleDays: 7,
    sampleTransport: "gulet",
    sampleProfileType: "luxury_sea",
    seedAnswers: {
      transport: "gulet",
      budget: "luxury",
      accommodation: "luxury",
      pace: "relaxed",
    },
  },
  {
    slug: "kapadokya-balon-ruya",
    title: "Kapadokya Balon Rüyası",
    subtitle: "Peri bacalarının üzerinde sinematik bir şafak vakti.",
    vibe: "cinematic",
    heroGradient: "from-orange-900 via-rose-800 to-amber-600",
    icon: "Mountain",
    highlights: [
      "Gün doğumunda sıcak hava balonu uçuşu",
      "Mağara butik otelde iki gece inziva",
      "Ihlara Vadisi yürüyüşü ve yeraltı şehirleri",
      "Özel fotoğraf turu, altın saat rotaları",
      "Şarap mahzenlerinde yerel Öküzgözü tadımı",
    ],
    sampleDays: 4,
    sampleTransport: "car",
    sampleProfileType: "adventure",
    seedAnswers: {
      transport: "car",
      budget: "comfortable",
      accommodation: "boutique",
      pace: "balanced",
    },
  },
  {
    slug: "italyan-rivieri",
    title: "İtalyan Rivierası",
    subtitle: "Cinque Terre'den Portofino'ya pastel bir sonat.",
    vibe: "romantic",
    heroGradient: "from-rose-900 via-fuchsia-700 to-amber-500",
    icon: "Waves",
    highlights: [
      "Beş renkli köy, beş ayrı hikâye",
      "Portofino'da özel tekne turu",
      "Liguria mutfağı: pesto ve focaccia atölyesi",
      "Santa Margherita'da deniz kenarı suite",
      "Porto Venere gün batımı siluet fotoğrafları",
    ],
    sampleDays: 8,
    sampleTransport: "mixed",
    sampleProfileType: "romantic",
    seedAnswers: {
      transport: "mixed",
      budget: "luxury",
      accommodation: "boutique",
      pace: "balanced",
    },
  },
  {
    slug: "iskandinav-fiyordlar",
    title: "İskandinav Fiyordları",
    subtitle: "Norveç'in sessizliği; buzul sularında bir road-trip.",
    vibe: "vast",
    heroGradient: "from-slate-900 via-sky-800 to-emerald-700",
    icon: "Tent",
    highlights: [
      "Geirangerfjord ve Nærøyfjord panoramaları",
      "Trolltunga yürüyüşü, kuzey ışıkları ihtimali",
      "Bergen'in renkli liman evlerinde sabah",
      "Atlantic Ocean Road üzerinde kıyı sürüşü",
      "Cam tavanlı lodge'ta yıldız gözlemi",
    ],
    sampleDays: 10,
    sampleTransport: "car",
    sampleProfileType: "adventure",
    seedAnswers: {
      transport: "car",
      budget: "luxury",
      accommodation: "boutique",
      pace: "balanced",
    },
  },
  {
    slug: "japonya-kiraz",
    title: "Japonya Kiraz Mevsimi",
    subtitle: "Tokyo'nun neonlarından Kyoto'nun tapınaklarına.",
    vibe: "delicate",
    heroGradient: "from-pink-900 via-rose-700 to-indigo-800",
    icon: "Flower2",
    highlights: [
      "Sakura sezonunda Meguro Nehri yürüyüşü",
      "Kyoto'da geleneksel ryokan deneyimi",
      "Özel çay seremonisi ve kaiseki akşamı",
      "Fushimi Inari'de gün doğumu",
      "Arashiyama bambu ormanında sessiz sabah",
    ],
    sampleDays: 10,
    sampleTransport: "train",
    sampleProfileType: "cultural_deep",
    seedAnswers: {
      transport: "train",
      budget: "luxury",
      accommodation: "boutique",
      pace: "balanced",
    },
  },
  {
    slug: "andalusya-ruzgari",
    title: "Endülüs Rüzgârı",
    subtitle: "İspanya'nın güneyinde flamenko, tapas ve altın saatler.",
    vibe: "passionate",
    heroGradient: "from-amber-900 via-red-800 to-rose-700",
    icon: "Utensils",
    highlights: [
      "Sevilla'da özel flamenko gecesi",
      "Cordoba Mezquita rehberli sabah turu",
      "Granada Alhambra saray kompleksi",
      "Jerez'de sherry mahzeni tadımı",
      "Ronda uçurumları üzerinde akşam yemeği",
    ],
    sampleDays: 9,
    sampleTransport: "car",
    sampleProfileType: "gastro_tour",
    seedAnswers: {
      transport: "car",
      budget: "comfortable",
      accommodation: "boutique",
      pace: "balanced",
    },
  },
  {
    slug: "hollanda-karavan",
    title: "Hollanda'dan Karavan Macerası",
    subtitle: "Kanallardan Alpler'e özgür bir karavan yolculuğu.",
    vibe: "free",
    heroGradient: "from-emerald-900 via-teal-700 to-sky-600",
    icon: "Caravan",
    highlights: [
      "Amsterdam başlangıç, Alpler bitişi",
      "Premium karavan, tam donanım",
      "Almanya Karaorman üzerinden İsviçre",
      "Göl kenarında ücretsiz kamp noktaları",
      "Yerel pazar rotaları ve şarap bölgeleri",
    ],
    sampleDays: 14,
    sampleTransport: "caravan",
    sampleProfileType: "road_trip",
    seedAnswers: {
      transport: "caravan",
      budget: "comfortable",
      accommodation: "camping",
      pace: "balanced",
    },
  },
  {
    slug: "maldivler-inziva",
    title: "Maldivler İnzivası",
    subtitle: "Sadece deniz, sessizlik ve siz. Overwater bir rüya.",
    vibe: "restorative",
    heroGradient: "from-cyan-900 via-teal-600 to-emerald-400",
    icon: "Leaf",
    highlights: [
      "Overwater villada yedi gece",
      "Günlük özel spa ve yoga seansları",
      "Şnorkel ve manta ray safarisi",
      "Şef masası gün batımı yemeği",
      "Detoks menüsü ve meditasyon atölyesi",
    ],
    sampleDays: 7,
    sampleTransport: "plane",
    sampleProfileType: "wellness",
    seedAnswers: {
      transport: "plane",
      budget: "luxury",
      accommodation: "luxury",
      pace: "relaxed",
    },
  },
];

export function getCollectionBySlug(slug: string): Collection | undefined {
  return COLLECTIONS.find((c) => c.slug === slug);
}
